module.exports = __webpack_public_path__ + "img/8245b9546eb6e6bce9360af29c8b453.7b0cab40.jpg";